import React from 'react';

interface ReportsTabBarProps {
  activeTab: 'reports' | 'documents';
  setActiveTab: (tab: 'reports' | 'documents') => void;
}

const ReportsTabBar: React.FC<ReportsTabBarProps> = ({ activeTab, setActiveTab }) => {
  return (
    <div className="mt-4 flex border-b border-gray-200 dark:border-gray-700" role="tablist" aria-label="Report sections">
      <button
        onClick={() => setActiveTab('reports')}
        role="tab"
        aria-selected={activeTab === 'reports'}
        className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px ${
          activeTab === 'reports'
            ? 'border-blue-600 text-blue-600 dark:border-blue-400 dark:text-blue-400'
            : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
        }`}
      >
        Reports
      </button>
      <button
        onClick={() => setActiveTab('documents')}
        role="tab"
        aria-selected={activeTab === 'documents'}
        className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px ${
          activeTab === 'documents'
            ? 'border-blue-600 text-blue-600 dark:border-blue-400 dark:text-blue-400'
            : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
        }`}
      >
        Attachment guidance
      </button>
    </div>
  );
};

export default ReportsTabBar;
